//Libraries
import _ from 'lodash'
import moment from 'moment'
import axios from 'axios'

//Components
import Section from '../../components/section'
import Header from '../../components/pageHeader'
import LongPress from '../../components/longPress'
import SectionSpacing from '../../components/sectionSpacing'
import { AiOutlineEdit } from 'react-icons/ai'
import { AiOutlineDelete } from 'react-icons/ai'

//Styling
import './classes.scss'
import '../../dashboard.scss'
import colours from './../../utilities/colours.scss'

//Functions and Data
import config from './config'
import baseconfig from '../../../../variables/config'
import React, { useEffect, useState, useCallback } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchClasses } from '../../../../modules/classes'
import { sendRequest } from '../../../../modules/admin'
import { isEqualDate, keys } from '../../utilities/calendarData.js'
import S3 from 'react-aws-s3'
import Dropzone from 'react-dropzone'

function Classes({ isOpen, sendRequest, classes }) {
  const [tab, setTab] = useState(0)
  const [tabs, setTabs] = useState([])
  const [showclasses, setShowclasses] = useState([])
  const [toggle, setToggle] = useState('')
  const [image, setImage] = useState('')
  const [content, setContent] = useState('')
  const [date, setDate] = useState({})
  const [editSwitch, setEditSwitch] = useState(-1)

  useEffect(() => {
    sendRequest(fetchClasses)
    fetchClassesList()
    const selectTab = i => {
      setTab(i)
      setEditSwitch(-1)
      setToggle('')
    }
    setTabs([
      { name: 'Active', cb: () => selectTab(0) },
      { name: 'Not Active', cb: () => selectTab(1) }
    ])
  }, [])

  const imageConfig = {
    bucketName: 'wackykingdom',
    dirName: 'media' /* optional */,
    region: 'eu-west-2',
    accessKeyId: process.env.REACT_APP_S3Key,
    secretAccessKey: process.env.REACT_APP_S3SecretAccessKey,
    s3Url: 'https://wackykingdom.s3.eu-west-2.amazonaws.com' /* optional */
  }

  const uploadImage = file => {
    const ReactS3Client = new S3(imageConfig)
    /*  Notice that if you don't provide a dirName, the file will be automatically uploaded to the root of your bucket */
    // console.log(imageConfig, "config");
    // console.log(file[0], "file");

    /* This is optional */
    const newFileName =
      'events-' + JSON.stringify(Date.now()) + '-' + file[0].name

    ReactS3Client.uploadFile(file[0], newFileName)
      .then(data => {
        const classes = [...showclasses]
        classes[editSwitch].image = data.location
        setImage(data.location)
        setShowclasses(classes)
      })
      .catch(err => console.error(err))

    /**
     * {
     *   Response: {
     *     bucket: "myBucket",
     *     key: "image/test-image.jpg",
     *     location: "https://myBucket.s3.amazonaws.com/media/test-file.jpg"
     *   }
     * }
     */
  }

  const isClassExpired = item => {
    if (!item || !item.endDate) return false
    const { day, month, year } = item.endDate
    const endDate = moment(`${day} ${month} ${year}`, ['D MMMM YYYY', 'D MMM YYYY'])
    if (!endDate.isValid()) return false
    return moment().startOf('day').isAfter(endDate)
  }

  const ticketsStructure = {
    name: '',
    ageDescription: '6 months - 12 years',
    phone: '01737 763 523',
    datesOfClass: [
      {
        date: '31 December 2030',
        length: 120,
        time: '15:00pm - 17:00pm'
      }
    ],
    startDate: {
      day: 17,
      month: 'May',
      year: 2026
    },
    endDate: {
      day: 17,
      month: 'May',
      year: 2026
    },
    classDescription: ['Add Content'],
    image: '',
    notes: ['Add Content'],
    prices: {
      ticketType1: 27500
    },
    ticketTitles: {
      ticketType1: {
        name: 'Event Booking',
        isFullTerm: false,
        membersOnly: false
      }
    },
    teacherName: '',
    studioName: '',
    link: ''
  }

  const fetchClassesList = async () => {
    let token = JSON.parse(window.localStorage.getItem('userData')).token
    const isSouthampton = baseconfig.branch === 'Southampton'
    // Nest (Southampton) has no /getAllClasses remote; its standard GET already returns all classes
    const path = isSouthampton
      ? '/WKClass' + baseconfig.branch + '?access_token=' + token
      : '/WKClass' + baseconfig.branch + '/getAllClasses?access_token=' + token
    const response = (await axios.get(baseconfig.serverURL + path)).data
    const classesData = Array.isArray(response) ? response : response.result || []
    setShowclasses(classesData)
  }

  const addClass = () => {
    var newClasses = [...showclasses]
    newClasses.push(ticketsStructure)
    setShowclasses(newClasses)
    setEditSwitch(-1)
    setToggle('')
    setTab(isClassExpired(ticketsStructure) ? 1 : 0)
  }

  const updateClass = async i => {
    const token = JSON.parse(window.localStorage.getItem('userData')).token
    const isSouthampton = baseconfig.branch === 'Southampton'
    const wkClass = showclasses[i]
    const modelPath = '/WKClass' + baseconfig.branch

    try {
      if (!wkClass.id) {
        await axios.post(
          baseconfig.serverURL + modelPath + '?access_token=' + token,
          wkClass
        )
      } else if (isSouthampton) {
        await axios.patch(
          baseconfig.serverURL +
            modelPath +
            '/' +
            wkClass.id +
            '?access_token=' +
            token,
          wkClass
        )
      } else {
        // LoopBack find() hides expired classes, so PATCH /id 404s.
        // /updateClass looks them up with showAll: true.
        await axios.patch(
          baseconfig.serverURL +
            modelPath +
            '/updateClass?id=' +
            wkClass.id +
            '&access_token=' +
            token,
          wkClass
        )
      }
      setEditSwitch(-1)
      setTab(isClassExpired(wkClass) ? 1 : 0)
      fetchClassesList()
    } catch (err) {
      const apiError =
        err.response &&
        err.response.data &&
        (err.response.data.error || err.response.data.message)
      throw new Error(apiError || 'Please fill all fields')
    }
  }

  const deleteClass = async i => {
    if (window.confirm('Are you sure you want to delete?')) {
      let token = JSON.parse(window.localStorage.getItem('userData')).token
      let response = []
      try {
        response = await axios.delete(
          baseconfig.serverURL +
            '/WKClass' +
            baseconfig.branch +
            '/' +
            showclasses[i].id +
            '?access_token=' +
            token
        )
        setEditSwitch(-1)
        fetchClassesList()
      } catch (err) {
        if (response.data.status === 'success') {
          console.log('response ok')
        } else {
          throw new Error(response.data.error)
        }
      }
    } else {
      console.log('cancel ok')
    }
  }

  const handleContent = event => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    setContent(value)
  }

  const handleDate = event => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    const newDate = { ...date }
    newDate[name] = value
    setDate(newDate)
  }

  const handleChange = (event, index) => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    var newData = { ...showclasses[editSwitch] }
    var newClasses = [...showclasses]

    if (
      name === 'classDescription' ||
      name === 'notes' ||
      name === 'datesOfClass'
    ) {
      newData[name][index] = value
      newClasses[index][name] = newData[name]
      setShowclasses(newClasses)
    } else {
      newData[name] = value
      newClasses[editSwitch][name] = value
      setShowclasses(newClasses)
    }
  }

  const handleChangeType = (event, type) => {
    const target = event.target
    const value = target.value
    const name = target.name
    var newClasses = [...showclasses]
    newClasses[editSwitch][type][name] = value
    setShowclasses(newClasses)
  }

  const handleChangeArrayType = (event, type, index) => {
    const target = event.target
    const value = target.value
    const name = target.name
    var newClasses = [...showclasses]
    newClasses[editSwitch][type][index][name] = value
    setShowclasses(newClasses)
  }

  const addContent = (option, i) => {
    var newClasses = [...showclasses]
    newClasses[i][option].push(content)
    setShowclasses(newClasses)
    setToggle('')
    setContent('')
  }

  const addDate = (option, i) => {
    var newClasses = [...showclasses]
    newClasses[i][option].push(date)
    setShowclasses(newClasses)
    setToggle('')
    setDate({})
  }

  const handleChangeTitle = event => {
    const target = event.target
    const value = target.value
    const name = target.name
    var newClasses = [...showclasses]
    newClasses[editSwitch]['ticketTitles'][name] = {
      name: value,
      isFullTerm: false,
      membersOnly: false
    }
    setShowclasses(newClasses)
  }

  const handleChangeDate = (event, type) => {
    const target = event.target
    const value = target.value
    const name = target.name
    var newClasses = [...showclasses]

    switch (type) {
      case 'startDate':
        newClasses[editSwitch]['startDate'][name] = value
        setShowclasses(newClasses)
        break
      case 'endDate':
        newClasses[editSwitch]['endDate'][name] = value
        setShowclasses(newClasses)
        break

      default:
        console.log('Sorry, we cannot find the field')
    }
  }

  const visibleClasses = showclasses
    .map((item, index) => ({ item, index }))
    .filter(({ item, index }) => {
      if (index === editSwitch) return true
      return tab === 1 ? isClassExpired(item) : !isClassExpired(item)
    })

  var classesList = visibleClasses.map(({ item, index }) => (
    <div className="orderContent" key={index}>
      {editSwitch === index ? (
        <li>
          <span>
            <label>Name:</label>
            <input
              value={item.name}
              name="name"
              className="column"
              placeholder="name"
              onChange={handleChange}
            />
          </span>
          <br />
          <span className="list">
            <label>Start Date:</label>
            <span className="list">
              <input
                value={item.startDate.day}
                type="number"
                name="day"
                onChange={event => handleChangeDate(event, 'startDate')}
              />
              <input
                value={item.startDate.month}
                name="month"
                onChange={event => handleChangeDate(event, 'startDate')}
              />
              <input
                value={item.startDate.year}
                type="number"
                name="year"
                onChange={event => handleChangeDate(event, 'startDate')}
              />
            </span>
          </span>
          <span className="list">
            <label>End Date:</label>
            <span className="list">
              <input
                value={item.endDate.day}
                type="number"
                name="day"
                onChange={event => handleChangeDate(event, 'endDate')}
              />
              <input
                value={item.endDate.month}
                name="month"
                onChange={event => handleChangeDate(event, 'endDate')}
              />
              <input
                value={item.endDate.year}
                type="number"
                name="year"
                onChange={event => handleChangeDate(event, 'endDate')}
              />
            </span>
          </span>
          <br />
          <span>
            <label>Link:</label>
            <input
              value={item.link}
              name="link"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
          </span>
          <span>
            <label>Class Description:</label>
            {item.classDescription.map((d, i) => (
              <textarea
                key={i + 'desc'}
                value={d}
                className="column"
                rows="5"
                name="classDescription"
                placeholder=""
                onChange={event => handleChange(event, i)}
              />
            ))}
            {toggle === 'classDescription' ? (
              <span></span>
            ) : (
              <div>
                <button onClick={() => setToggle('classDescription')}>
                  Add New Paragraph
                </button>
              </div>
            )}
            {toggle === 'classDescription' ? (
              <textarea
                value={content}
                className="column"
                rows="5"
                name="classDescription"
                placeholder=""
                onChange={handleContent}
              />
            ) : (
              <span></span>
            )}
            {toggle === 'classDescription' ? (
              <div>
                <button onClick={() => addContent('classDescription', index)}>
                  Save
                </button>
                <button onClick={() => setToggle('')}>Remove</button>
              </div>
            ) : (
              <span></span>
            )}
          </span>
          <span>
            <label>Notes:</label>
            {item.notes.map((n, j) => (
              <textarea
                key={j + 'note'}
                value={n}
                className="column"
                rows="5"
                name="notes"
                placeholder=""
                onChange={event => handleChange(event, j)}
              />
            ))}
            {toggle === 'notes' ? (
              <span></span>
            ) : (
              <div>
                <button onClick={() => setToggle('notes')}>
                  Add New Paragraph
                </button>
              </div>
            )}
            {toggle === 'notes' ? (
              <textarea
                value={content}
                className="column"
                rows="5"
                name="notes"
                placeholder=""
                onChange={handleContent}
              />
            ) : (
              <span></span>
            )}
            {toggle === 'notes' ? (
              <div>
                <button onClick={() => addContent('notes', index)}>Add</button>
                <button onClick={() => setToggle('')}>Remove</button>
              </div>
            ) : (
              <span></span>
            )}
          </span>
          <span>
            <label>Date Time:</label>
            {item.datesOfClass.map((date, k) => (
              <span className="list" key={k + 'date'}>
                <input
                  value={date.dayOfWeek? date.dayOfWeek : date.date}
                  name={date.dayOfWeek ? "dayOfWeek" : "date"}
                  onChange={event =>
                    handleChangeArrayType(event, 'datesOfClass', k)
                  }
                />
                <input
                  value={date.time}
                  name="time"
                  onChange={event =>
                    handleChangeArrayType(event, 'datesOfClass', k)
                  }
                />
                <input
                  value={date.length}
                  type="number"
                  name="length"
                  onChange={event =>
                    handleChangeArrayType(event, 'datesOfClass', k)
                  }
                />
              </span>
            ))}
            {toggle === 'datesOfClass' ? (
              <span></span>
            ) : (
              <div>
                <button onClick={() => setToggle('datesOfClass')}>
                  Add New
                </button>
              </div>
            )}
            {toggle === 'datesOfClass' ? (
              <span className="list" key={item.datesOfClass.length + 'date'}>
                <input
                  value={date.dayOfWeek}
                  name="dayOfWeek"
                  onChange={handleDate}
                />
                <input value={date.time} name="time" onChange={handleDate} />
                <input
                  value={date.length}
                  type="number"
                  name="length"
                  onChange={handleDate}
                />
              </span>
            ) : (
              <span></span>
            )}
            {toggle === 'datesOfClass' ? (
              <div>
                <button onClick={() => addDate('datesOfClass', index)}>
                  Save
                </button>
                <button onClick={() => setToggle('')}>Remove</button>
              </div>
            ) : (
              <span></span>
            )}
          </span>
          <span>
            <label>Phone:</label>
            <input
              value={item.phone}
              name="phone"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
          </span>
          <br />
          <span>
            <label>Image:</label>
            <input
              value={item.image}
              name="image"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
          </span>
          <Dropzone onDrop={acceptedFiles => uploadImage(acceptedFiles)}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <button>Upload Image</button>
                </div>
              </section>
            )}
          </Dropzone>
          <br />
          <label>Private Link:</label>
          <label className="switch">
            <input
              type="checkbox"
              name="isHidden"
              checked={item.isHidden}
              onChange={handleChange}
            />
            <span className="slider round"></span>
          </label>
          <br />
          <p>Prices</p>
          <span>
            <label>Ticket Type 1:</label>
            <input
              value={
                item.ticketTitles.ticketType1
                  ? item.ticketTitles.ticketType1.name
                  : ''
              }
              name="ticketType1"
              className="column"
              placeholder=""
              onChange={handleChangeTitle}
            />
          </span>
          <span>
            <label>Ticket Type 1 Price:</label>
            <input
              value={item.prices.ticketType1}
              type="number"
              name="ticketType1"
              className="column"
              placeholder=""
              onChange={event => handleChangeType(event, 'prices')}
            />
          </span>
          <br />
          <span>
            <label>Ticket Type 2:</label>
            <input
              value={
                item.ticketTitles.ticketType2
                  ? item.ticketTitles.ticketType2.name
                  : ''
              }
              name="ticketType2"
              className="column"
              placeholder=""
              onChange={event => handleChangeTitle(event)}
            />
          </span>
          <span>
            <label>Ticket Type 2 Price:</label>
            <input
              value={item.prices.ticketType2}
              type="number"
              name="ticketType2"
              className="column"
              placeholder=""
              onChange={event => handleChangeType(event, 'prices')}
            />
          </span>
          <br />
          <span>
            <label>Ticket Type 3:</label>
            <input
              value={
                item.ticketTitles.ticketType3
                  ? item.ticketTitles.ticketType3.name
                  : ''
              }
              name="ticketType3"
              className="column"
              placeholder=""
              onChange={handleChangeTitle}
            />
          </span>
          <span>
            <label>Ticket Type 3 Price:</label>
            <input
              value={item.prices.ticketType3}
              name="ticketType3"
              type="number"
              className="column"
              placeholder=""
              onChange={event => handleChangeType(event, 'prices')}
            />
          </span>
          <br />
          <span>
            <label>Ticket Type 4:</label>
            <input
              value={
                item.ticketTitles.ticketType4
                  ? item.ticketTitles.ticketType4.name
                  : ''
              }
              name="ticketType4"
              className="column"
              placeholder=""
              onChange={handleChangeTitle}
            />
          </span>
          <span>
            <label>Ticket Type 4 Price:</label>
            <input
              value={item.prices.ticketType4}
              name="ticketType4"
              type="number"
              className="column"
              placeholder=""
              onChange={event => handleChangeType(event, 'prices')}
            />
          </span>
          <br />
          <span>
            <label>Ticket Type 5:</label>
            <input
              value={
                item.ticketTitles.ticketType5
                  ? item.ticketTitles.ticketType5.name
                  : ''
              }
              name="ticketType5"
              className="column"
              placeholder=""
              onChange={handleChangeTitle}
            />
          </span>
          <span>
            <label>Ticket Type 5 Price:</label>
            <input
              value={item.prices.ticketType5}
              name="ticketType5"
              type="number"
              className="column"
              placeholder=""
              onChange={event => handleChangeType(event, 'prices')}
            />
          </span>
          <br />
          <span>
            <label>Ticket Type 6:</label>
            <input
              value={
                item.ticketTitles.ticketType6
                  ? item.ticketTitles.ticketType6.name
                  : ''
              }
              name="ticketType6"
              className="column"
              placeholder=""
              onChange={handleChangeTitle}
            />
          </span>
          <span>
            <label>Ticket Type 6 Price:</label>
            <input
              value={item.prices.ticketType6}
              name="ticketType6"
              type="number"
              className="column"
              placeholder=""
              onChange={event => handleChangeType(event, 'prices')}
            />
          </span>
          <div className="orderOperation">
            <button onClick={() => setEditSwitch(-1)}>{'Cancel'}</button>
            <button onClick={() => updateClass(index)}>{'Save'}</button>
          </div>
        </li>
      ) : (
        <li>
          <h3>
            {item.name}{' '}
            {isClassExpired(item) && (
              <span className="notActive">(NOT ACTIVE)</span>
            )}
          </h3>
          <div className="column">
            Start Date:{' '}
            {item.startDate.day +
              ' ' +
              item.startDate.month +
              ' ' +
              item.startDate.year}
          </div>
          <div className="column">
            End Date:{' '}
            {item.endDate.day +
              ' ' +
              item.endDate.month +
              ' ' +
              item.endDate.year}
          </div>
          <div className="column">Event Link: {item.link}</div>
        </li>
      )}
      <div className="orderOperation">
        <button onClick={() => deleteClass(index)}>{'Delete'}</button>

        {editSwitch === index ? (
          <button onClick={() => updateClass(index)}>{'Save'}</button>
        ) : (
          <button onClick={() => setEditSwitch(index)}>{'Edit'}</button>
        )}
      </div>
    </div>
  ))

  return (
    <div className="ordersContainer">
      <Header
        title={config.mainTitle}
        tip={config.subHeading}
        icon={config.titleIcon}
        tabs={tabs}
        selected={tab}
      />
      <div className="orderList">
        {visibleClasses.length === 0 ? (
          <div className="orderEmpty">
            {tab === 0 ? 'No active events' : 'No events that are not active'}
          </div>
        ) : (
          classesList
        )}
      </div>
      <button onClick={() => addClass()}>{'Add New Event'}</button>
    </div>
  )
}

const mapStateToProps = ({ classes }) => ({
  classes: classes
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ sendRequest }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Classes)
